import React, {useState, useEffect} from 'react';
import {
    Box,
    Paper,
    Tabs,
    Tab,
    Typography,
    CircularProgress,
} from '@mui/material';
import {toast} from 'react-toastify';
import api from 'utils/api';

import ConfigList from './ConfigList';
import ConfigEditor from './ConfigEditor';

const styles = {
    paper: {
        p: {xs: 2, md: 3},
    },
    header: {
        mb: 3,
    },
    title: {
        fontWeight: 600,
        fontSize: {xs: '1.25rem', md: '1.5rem'},
        mb: 1,
    },
    description: {
        color: 'text.secondary',
        fontSize: '0.875rem',
    },
    tabs: {
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
    },
};

export default function ConfigGeneratorPage() {
    const [tab, setTab] = useState(0);
    const [schemas, setSchemas] = useState({});
    const [loading, setLoading] = useState(true);

    // 편집 모드 관련 상태
    const [editingPreset, setEditingPreset] = useState(null);

    useEffect(() => {
        loadSchemas();
    }, []);

    const loadSchemas = async () => {
        try {
            const res = await api.get('/api/config/schemas');
            setSchemas(res.data);
        } catch (err) {
            toast.error('설정 스키마를 불러오는데 실패했습니다.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // 프리셋 편집 시작
    const handleEdit = (preset) => {
        setEditingPreset(preset);
        setTab(1); // 설정 생성 탭으로 이동
    };

    // 편집 완료/취소
    const handleEditorClose = () => {
        setEditingPreset(null);
    };

    // 저장 완료 시 목록으로 돌아가기
    const handleSaveComplete = () => {
        setEditingPreset(null);
        setTab(0); // 목록 탭으로 이동
    };

    return (
        <Box>
            <Paper sx={styles.paper}>
                <Box sx={styles.header}>
                    <Typography sx={styles.title}>
                        설정 생성기
                    </Typography>
                    <Typography sx={styles.description}>
                        제품별 config-override.properties 파일을 생성하고 관리합니다.
                    </Typography>
                </Box>

                <Tabs
                    value={tab}
                    onChange={(e, v) => {
                        setTab(v);
                        if (v === 0) {
                            setEditingPreset(null);
                        }
                    }}
                    sx={styles.tabs}
                >
                    <Tab label="설정 목록"/>
                    <Tab label={editingPreset ? "설정 수정" : "새 설정 생성"}/>
                </Tabs>

                {loading ? (
                    <Box sx={styles.loading}>
                        <CircularProgress/>
                    </Box>
                ) : (
                    <>
                        {tab === 0 && (
                            <ConfigList
                                schemas={schemas}
                                onEdit={handleEdit}
                            />
                        )}
                        {tab === 1 && (
                            <ConfigEditor
                                schemas={schemas}
                                editingPreset={editingPreset}
                                onClose={handleEditorClose}
                                onSaveComplete={handleSaveComplete}
                            />
                        )}
                    </>
                )}
            </Paper>
        </Box>
    );
}
